function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M13.0156 2.01489C13.5679 2.01489 14.0156 2.46261 14.0156 3.01489V8.03434C14.0156 8.58663 14.4633 9.03434 15.0156 9.03434C15.5679 9.03434 16.0156 8.58663 16.0156 8.03434V3.01489C16.0156 1.35804 14.6725 0.0148926 13.0156 0.0148926H3.01562C1.35877 0.0148926 0.015625 1.35804 0.015625 3.01489V17.0149C0.015625 18.6717 1.35877 20.0149 3.01562 20.0149H6.50073C7.05301 20.0149 7.50073 19.5672 7.50073 19.0149C7.50073 18.4626 7.05301 18.0149 6.50073 18.0149H3.01562C2.46334 18.0149 2.01562 17.5672 2.01562 17.0149V3.01489C2.01562 2.46261 2.46334 2.01489 3.01562 2.01489H13.0156Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M5.00073 4.99999C4.44844 4.99999 4.00073 5.44771 4.00073 5.99999C4.00073 6.55228 4.44844 6.99999 5.00073 6.99999H11.0007C11.553 6.99999 12.0007 6.55228 12.0007 5.99999C12.0007 5.44771 11.553 4.99999 11.0007 4.99999H5.00073Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M4.00083 10C4.00083 9.44771 4.44855 9 5.00083 9H9.00083C9.55312 9 10.0008 9.44771 10.0008 10C10.0008 10.5523 9.55312 11 9.00083 11H5.00083C4.44855 11 4.00083 10.5523 4.00083 10Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M19.76 11.6508C20.1194 11.2315 20.0709 10.6002 19.6515 10.2407C19.2322 9.88132 18.6009 9.92988 18.2415 10.3492L12.9443 16.5293L11.2078 14.7929C10.8173 14.4024 10.1841 14.4024 9.79363 14.7929C9.4031 15.1834 9.4031 15.8166 9.79363 16.2071L12.2936 18.7071C12.4906 18.9041 12.7608 19.0099 13.0391 18.9993C13.3174 18.9886 13.5787 18.8623 13.76 18.6508L19.76 11.6508Z"
});

function SvgDocumentCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCheck);
export default __webpack_public_path__ + "static/media/DocumentCheck.c26b2f06.svg";
export { ForwardRef as ReactComponent };